import { IUserFromToken } from '@lifk/types'

// Roles ordered from least to most privileged
export enum RolesByPrivilege {
  'public',
  'guest',
  'user',
  'admin'
}

export const roleAtLeast = (
  user: IUserFromToken | null,
  threshold: RolesByPrivilege
): boolean => {
  const userRole =
    RolesByPrivilege[user?.role as keyof typeof RolesByPrivilege] ??
    RolesByPrivilege.public
  return userRole >= threshold
}

export const isUserRoute = (accessLevel?: number) => {
  return accessLevel !== undefined && accessLevel >= RolesByPrivilege.user
}
